import { Box, Button, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { usersListAppraisalCycle } from '../../../../components/datagrid/appraisal/usersListAppraisalCycle';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllUsersUnderAppraisalCycle } from '../../../../redux/features/appraisalSlice';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import { Icon } from '@iconify/react/dist/iconify.js';

const ManagerUserListingLanding = ({ goBack, selectedCycleId, cycleName }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [gridSize, setGridSize] = useState(10);
  const { loading, usersList } = useSelector((state) => state.appraisal);
  const dispatchParams = {
    cycleId: selectedCycleId,
  };
  useEffect(() => {
    dispatch(getAllUsersUnderAppraisalCycle(dispatchParams));
  }, [selectedCycleId]);

  return (
    <>
      <Box>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Icon icon="ion:arrow-back-circle" height={22} width={22} />}
          onClick={() => goBack()}
          sx={{ mb: 1,px:1 }}
        >
          Go Back
        </Button>
        <Paper>
          <DataGrid
            components={{ Toolbar: CustomGridToolbar }}
            rows={usersList}
            columns={usersListAppraisalCycle(
              selectedCycleId,
              cycleName,
              getAllUsersUnderAppraisalCycle,
              dispatchParams
            )}
            loading={loading}
            getRowId={(row) => row.sl_no}
            pageSize={gridSize}
            autoHeight
            rowsPerPageOptions={[5, 10, 25, 50]}
            onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
          />
        </Paper>
      </Box>
    </>
  );
};

export default ManagerUserListingLanding;
